<template>
  <dn-infobox
    v-if="$slots.default || bullets"
    class="dn-summary"
    :disclosure="{offIcon:'info', content: t('summary.disclosure'), track: {eventName: 'Summarizer Disclosure Text', elementName: 'dn-summary', elementId: 'disclosure'} }"
    :title="title || t('summary.title')"
    :toggle="{track: {eventName: 'Summarizer Main Text', elementName: 'dn-summary', elementId: 'toggle'}}"
  >
    <slot>
      <dn-text-entity
        v-if="typeof bullets === 'string'"
        tag="div"
        :content="bullets"
      />
      <ul v-else>
        <li
          v-for="bullet in bullets"
          :key="bullet"
        >
          {{ bullet }}
        </li>
      </ul>
    </slot>
  </dn-infobox>
</template>

<script setup lang="ts">
const { t } = useI18n();
defineProps({
  title: {
    type: String,
    required: false,
    default: null,
    validator: (value: string) => value.length > 0
  },
  bullets: {
    type: [String, Array],
    required: false,
    default: () => {}
  }
});
</script>

<style lang="scss">
.dn-summary {
  --dn-infobox_grid-template: var(--dn-summary_grid-template, auto / auto 28px );
  --dn-infobox_gap: var(--dn-summary_gap);
  --dn-infobox_title_grid-area: var(--dn-summary_title_grid-area, 1 / 1 / auto / 2);
  --dn-infobox_content_grid-area: var(--dn-summary_content_grid-area, auto / 1 / auto / 3);
  --dn-infobox_content_max-block-size: var(--dn-summary_content_max-block-size);
  --dn-infobox_button_grid-area: var(--dn-summary_button_grid-area, auto / 1 / auto / 3);
  --dn-infobox_background-color: var(--dn-summary_background-color);
  --dn-infobox_border-radius: var(--dn-summary_border-radius);
  --dn-infobox_padding: var(--dn-summary_padding);
  --dn-infobox_title_color: var(--dn-summary_title_color);
  --dn-infobox_title_font-family: var(--dn-summary_title_font-family);
  --dn-infobox_title_font-size: var(--dn-summary_title_font-size);
  --dn-infobox_title_font-weight: var(--dn-summary_title_font-weight);
  --dn-infobox_title_line-height: var(--dn-summary_title_line-height);
  --dn-infobox_content_color: var(--dn-summary_content_color);
  --dn-infobox_content_font-family: var(--dn-summary_content_font-family);
  --dn-infobox_content_font-size: var(--dn-summary_content_font-size);
  --dn-infobox_content_line-height: var(--dn-summary_content_line-height);
  --dn-infobox_disclosure-content_color: var(--dn-summary_disclosure-content_color);
  --dn-infobox_disclosure-content_font-family: var(--dn-summary_disclosure-content_font-family);
  --dn-infobox_disclosure-content_font-size: var(--dn-summary_disclosure-content_font-size);
  --dn-infobox_disclosure-content_line-height: var(--dn-summary_disclosure-content_line-height);
  --dn-infobox_button_background-color: var(--dn-summary_button_background-color);
  --dn-infobox_button_color: var(--dn-summary_button_color);
  --dn-infobox_button_border-color: var(--dn-summary_button_border-color);
  --dn-infobox_button_border-radius: var(--dn-summary_button_border-radius);
  --dn-infobox_button_font-family: var(--dn-summary_button_font-family);
  --dn-infobox_button_font-size: var(--dn-summary_button_font-size);
  --dn-infobox_button_inline-size: var(--dn-summary_button_inline-size);
  --dn-infobox_button_max-width: var(--dn-summary_button_max-width);
  --dn-infobox_button_padding: var(--dn-summary_button_padding);
  --dn-infobox_button_border: var(--dn-summary_button_border);

  .content ul {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}
</style>
